import { render, staticRenderFns } from "./SchoolInfoScreen.vue?vue&type=template&id=83cbba5e&scoped=true"
import script from "./SchoolInfoScreen.vue?vue&type=script&lang=js"
export * from "./SchoolInfoScreen.vue?vue&type=script&lang=js"
import style0 from "./SchoolInfoScreen.vue?vue&type=style&index=0&id=83cbba5e&prod&lang=stylus&scoped=true"
import style1 from "./SchoolInfoScreen.vue?vue&type=style&index=1&id=83cbba5e&prod&lang=stylus"
import style2 from "./SchoolInfoScreen.vue?vue&type=style&index=2&id=83cbba5e&prod&lang=stylus&scoped=true"
import style3 from "./SchoolInfoScreen.vue?vue&type=style&index=3&id=83cbba5e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cbba5e",
  null
  
)

export default component.exports